import React, { useState } from "react";
import logo from "../../assets/images/brand-logos/desktop-logo.png";
import logo1 from "../../assets/images/brand-logos/desktop-dark.png";
import Step1 from "./steps/step1";
import Step2 from "./steps/step2";
import Signinmodal from "../signinmodal/signin";

const Signupmodal = () => {
  const [showSigninModal, setShowSigninModal] = useState(false);
  const [showStep1Modal, setShowStep1Modal] = useState(false);
  const [showStep2Modal, setShowStep2Modal] = useState(false);
 
  const handleShowSigninModal = () => setShowSigninModal(true);
  const handleCloseSigninModal = () => setShowSigninModal(false);

  const handleShowStep1Modal = () => {

    setShowStep1Modal(true);
  };
  const handleCloseStep1Modal = () => setShowStep1Modal(false);
  const handleModal2Close = () => {
    console.log("Closing modal...");
    setShowStep2Modal(false);  
  };
  

  const handleShowStep2Modal = () => {

    setShowStep1Modal(false); 
    setShowStep2Modal(true);  
  };

 

  return (
    <div className="page error-bg" id="particles-js">
      <div className="error-page">
        <div className="container-lg">
          <div className="row justify-content-center align-items-center authentication authentication-basic h-100">
            <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-6 col-sm-8 col-12">
              <div className="my-5 d-flex justify-content-center">
                <a href="index.html">
                  <img src={logo} alt="logo" className="desktop-logo" />
                  <img src={logo1} alt="logo" className="desktop-dark" />
                </a>
              </div>
              <div className="card custom-card rectangle2">
                <div className="card-body p-sm-5 p-3 rectangle3">
                  <div className="text-center">
                    <h4 className="mb-4">Choose your option</h4>
                    <div className="btn-list d-flex flex-column gap-3">
                      <button
                        onClick={handleShowSigninModal}
                        className="btn btn-lg btn-outline-primary w-100"
                      >
                        Sign In
                      </button>

                      <button
                        onClick={handleShowStep1Modal}
                        className="btn btn-lg btn-outline-primary w-100"
                      >
                        Sign Up
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    
      <Signinmodal
        showModal={showSigninModal}
        handleModalClose={handleCloseSigninModal}
        openStep1Modal={handleShowStep1Modal}
        dialogClassName="custom-modal"
      />


      <Step1
        showModal={showStep1Modal}
        handleModalClose={handleCloseStep1Modal}
        openStep2Modal={handleShowStep2Modal}
        openSigninModal={handleShowSigninModal}
  
        dialogClassName="custom-modal"
      />

     
      <Step2
        showModal={showStep2Modal}
        handleModal2Close={handleModal2Close}
        openSigninModal={handleShowSigninModal}
        dialogClassName="custom-modal"
      />
    </div>
  );
};

export default Signupmodal;
